module.exports = "//docs.gtimg.com/slide/img/framework/frame/components/animation-editor/images/smart-image-7a6b96.svg";